import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import Lottie from "react-lottie";
import animationData from "../resources/queue-animation.json.js";
class QueueView extends Component {
  constructor(props) {
    super(props);
    this.getQueuePositionMessage = this.getQueuePositionMessage.bind(this);
    this.formatQueuePositionMessage = this.formatQueuePositionMessage.bind(this);
  }
  formatQueuePositionMessage(message) {
    const [title, body] = Array.isArray(message) ? message : message.split(";");
    return {
      body,
      title
    };
  }
  getQueuePositionMessage(messages, positionInQueue) {
    var _a;
    if (!messages || !positionInQueue)
      return this.formatQueuePositionMessage([
        "You've now joined the queue",
        `${parseInt(this.props.wait, 10) > 0 ? `your estimated wait time is ${Math.ceil(
          this.props.wait / 60
        )} minutes` : ""}`
      ]);
    const sortedMessages = messages == null ? void 0 : messages.sort(
      (messageA, messageB) => messageA.queuePosition > messageB.queuePosition
    );
    const message = (_a = sortedMessages.find(
      (message2) => positionInQueue >= (message2 == null ? void 0 : message2.queuePosition)
    )) == null ? void 0 : _a.message;
    if (message) {
      return this.formatQueuePositionMessage(message);
    }
    const defaultMessage = sortedMessages[sortedMessages.length - 1].message;
    return this.formatQueuePositionMessage(defaultMessage);
  }
  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };
    const positionMessage = this.getQueuePositionMessage(
      this.props.queuePositionMessages,
      this.props.queuePosition
    );
    return /* @__PURE__ */ jsxs("div", { id: "queue-view", children: [
      /* @__PURE__ */ jsx("div", { id: "msg-wait-time", children: /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { id: "msg-wait-title", children: positionMessage == null ? void 0 : positionMessage.title }),
        /* @__PURE__ */ jsx("div", { id: "msg-wait-body", children: positionMessage == null ? void 0 : positionMessage.body })
      ] }) }),
      /* @__PURE__ */ jsxs("div", { id: "block-queue-position", children: [
        /* @__PURE__ */ jsx("div", { id: "msg-queue-position", children: "Your queue position is" }),
        /* @__PURE__ */ jsxs("div", { id: "queue-animation", children: [
          /* @__PURE__ */ jsx(
            Lottie,
            {
              options: defaultOptions,
              isStopped: false,
              isPaused: false
            }
          ),
          /* @__PURE__ */ jsx("div", { id: "queue-position", children: this.props.queuePosition || 0 })
        ] })
      ] }),
      this.props.message ? /* @__PURE__ */ jsxs("div", { id: "msg-queue-message", children: [
        /* @__PURE__ */ jsx("div", { id: "msg-queue-title", children: this.props.message.title }),
        /* @__PURE__ */ jsx("div", { id: "msg-queue-content", children: this.props.message.body })
      ] }) : null,
      /* @__PURE__ */ jsx("div", { id: "leave-queue", children: /* @__PURE__ */ jsx("button", { id: "leave-queue-button", onClick: this.props.leaveQueue, children: "Leave the queue" }) })
    ] });
  }
}
QueueView.propTypes = {
  leaveQueue: PropTypes.func,
  queuePosition: PropTypes.number,
  wait: PropTypes.number,
  message: PropTypes.object,
  queuePositionMessages: PropTypes.array
};
export {
  QueueView as default
};
//# sourceMappingURL=QueueView.js.map
